const atc = document.querySelector('.add-to-cart');
const elements = document.querySelectorAll('.prl-shipping');

atc.disabled = true;

const checkPrsShipping = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    let selectedMethod = false;
    let variantSelected = '';
    elements.forEach(element => {
        if(element.checked){
            selectedMethod = true;
            variantSelected = element.dataset.vid;
        }
    });
    if(selectedMethod === false || variantSelected === '') {
        return false;
    }else{
        addToCart(evt, variantSelected);
    }
};

const addToCart = (evt, variant) => {
    const button = evt.target;
    button.classList.add('btn--loading');
    const items = [{
        id: variant,
        quantity: 1
    }];
    fetch('/cart/add.js', {
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        method: 'POST',
        body: JSON.stringify({
            items: items,
        })
    }).then(result => {
        const formId = document.getElementById('prl-form').value;
        document.getElementById(formId).submit();
    });
};

const enableAtc = () => {
    atc.disabled = false;
};

elements.forEach(element => element.addEventListener('change', enableAtc));
atc.addEventListener('click', checkPrsShipping);
